import supabase from "../../../shared/database/supabase";
import { CustomError } from "../../../shared/error/error";

export interface CreateInvoicePaymentRequest {
  id_invoice: string;
  amount: number;
  discount_percentage: number;
  payed_at: Date;
}

export interface CreateInvoicePaymentResponse {
  id: string;
}

export const createInvoicePaymentReq = async (req: CreateInvoicePaymentRequest): Promise<CreateInvoicePaymentResponse> => {
  try {
    const { data, error } = await supabase.functions.invoke("create-invoice-payment", {
      body: JSON.stringify({ ...req })
    });

    if (error) throw error;
    if (data.error) throw data.error;

    return data;
  } catch (err) {
    const apiError = err as CustomError;
    console.error(`API Error: ${apiError.message}`);

    if (apiError && apiError.code && apiError.message && apiError.toast_message && apiError.http_status_code) {
      throw new CustomError(apiError);
    }

    throw new CustomError({});
  }
};
